import {
	CargoContractSides,
	FixtureTypes,
} from '@shared/utils/constants';
import getAvailableFreightInvoiceItems from '@shared/utils/getAvailableFreightInvoiceItems';
import { GetVoyageDetailsResponse } from '@api/features/voyages/getVoyageDetails';
import { GetFixtureDetailsResponse } from '@api/features/fixtures/getFixtureDetails';
import { SpotFixtureProps } from '@api/models/spot-fixture';
import { VoyageInvoice } from '@api/utils/sequelize/getAllVoyageInvoices';
import { BankAccountProps } from '@api/models/bank-account';
import { GetCargosAndLaytimesResponse } from '@api/features/laytime/getCargosAndLaytimes';

const getAvailableHIIsFromSpotDetails = (
	voyageDetails: GetVoyageDetailsResponse,
	fixtureDetails: GetFixtureDetailsResponse<SpotFixtureProps>,
	invoices: VoyageInvoice[],
	chartererId: number,
	selectedBankAccount: BankAccountProps,
	cargos: GetCargosAndLaytimesResponse['cargosAndLaytimes'],
	contractSide: CargoContractSides = CargoContractSides.VC_OUT,
) => {
	const {
		voyageExpenseReceivables,
		revenueItems,
	} = voyageDetails;

	const {
		brokers,
		type,
	} = fixtureDetails;

	if (selectedBankAccount == null) {
		return [];
	}

	if (type !== FixtureTypes.SPOT) {
		return [];
	}

	return getAvailableFreightInvoiceItems({
		type,
		brokers,
		cargos: cargos ?? [],
		chartererId,
		hireInvoices: invoices ?? [],
		voyageExpenseReceivables,
		revenueItems,
		selectedBankAccount,
		amendments: voyageDetails.amendments ?? [],
		contractSide,
	});
};

export default getAvailableHIIsFromSpotDetails;
